<template>
  <div class='head'>
    <!-- pc顶部登录信息显示框开始 -->
    <div class='userinfobox'>
      <div class='userinfo'>
        <span class='logininfo' @click='loginShow()' v-if="user_datas.length === 0">您好，请登录</span>
        <div class='userinfo_details'  v-if="user_datas.length !== 0">
          <span>{{ user_datas.account }}</span>
          <span>{{grade_name}}</span>
          <span class='logout'>
            <!--<i></i>-->积分 {{ score_show.score_show }}
            <label @click="refresh()">[ 刷新 ]</label>
          </span>
          <span class='mgr0'>
            <a @click='logOff()'>[ 注销 ]</a>
          </span>
        </div>
      </div>
    </div>
    <!-- pc顶部登录信息显示框结束 -->
    <!-- pc菜单栏菜单栏开始 -->
    <div class='navbg'>
      <div class='vipbox'>
        <a href='/'><img src='../../../static/img/home/navlogo.png' class='navlogo'></a>
        <ul class='nav'>
          <li v-for='(data,index) in header_list' :key='index' @click="menuShow(index)">
            <router-link :to='data.url' :class="{'choose':msg_reads.msg_reads === index}">
              {{data.name}}
              <span>{{data.english}}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <!-- pc菜单栏菜单栏结束 -->
    <Login v-show = 'login_show' class="animate"></Login>
    <prompt v-if='prompt_show'></prompt>
    <Loading v-if='loading'></Loading>
  </div>
</template>
<script type='text/javascript'>
import {mapGetters} from 'vuex'
import Login from './Login'
import Prompt from './Prompt'
import Loading from './loading'
export default {
  data () {
    return {
      header_list: [
        {
          name: '首  页',
          english: 'HOME',
          url: '/'
        }, {
          name: '游戏特权',
          english: 'GAME PRIVILEGE',
          url: '/vipgamePrivilege?classify_index=0'
        }, {
          name: '服务特权',
          english: 'SERVICE PRIVILEGE',
          url: '/vipServicePrivilege'
        }, {
          name: '资讯中心',
          english: 'NEWS CENTER',
          url: '/vipNewsCenter?news_index=0'
        }, {
          name: '个人中心',
          english: 'USER CENTER',
          url: '/personalCenter?person_index=0'
        }, {
          name: '会员体系',
          english: 'MEMBERSHIP',
          url: '/vipMember'
        }
      ],
      total_score: 0,
      loading: false,
      vip_info: {},
      grade_name: '九龙阁一级'
    }
  },
  computed: {
    ...mapGetters([
      'user_datas',
      'login_show',
      'choose_menu',
      'prompt_show',
      'msg_reads',
      'score_show'
    ])
  },
  components: {
    Loading,
    Login,
    Prompt
  },
  methods: {
    loginShow () {
      this.$store.dispatch('change_login_show', true)
    },
    logOff () {
      this.$store.dispatch('change_prompt_show', true)
      this.$store.dispatch('set_prompt_info', '是否确认注销？')
      this.$store.dispatch('set_prompt_type_param', {type: 'log_off'})
    },
    linkclick () {
      document.querySelector('.navbg .nav li:nth-child(5) a').className = ''
    },
    menuShow (index) {
      this.$store.commit('SET_READ', {msg_reads: index})
      this.$store.dispatch('choose_menu', index)
    },
    // 刷新积分
    refresh () {
      this.loading = true
      this.axios.post(' /api/interface/personal_center/refresh_recharge').then(res => {
        if (res.data.state === 0) {
          this.loading = false
          window.location.reload()
          this.getData()
        }
      })
    },
    // 登录过期
    LogonExpires () {
      const now = new Date()
      const dateime = now.getFullYear() + '-' + ((now.getMonth() + 1) < 10 ? '0' : '') + (now.getMonth() + 1) + '-' + (now.getDate() < 10 ? '0' : '') + now.getDate()
      if (localStorage.data) {
        if (JSON.parse(localStorage.data).time !== dateime) {
          this.$store.dispatch('clear_baseinfo')
        }
      }
    },
    // 获取积分信息
    getData () {
      var pageInfo = {
        page: 1,
        page_size: 5
      }
      this.axios.post('/api/interface/personal_center/my_score', pageInfo).then(res => {
        if (res.data.state === 0) {
          this.total_score = res.data.score
          this.$store.commit('SCORE_SHOW', {score_show: this.total_score})
        }
      })
      this.getGrade()
    },
    getGrade () {
      if (this.user_datas.length !== 0) {
        this.axios.get('/api/interface/personal_center/get_vip_info').then(res => {
          if (res.data.state === 0) {
            this.vip_info = res.data
            if (this.vip_info.vip_lv === 1) {
              this.grade_name = '九龙阁一级'
            } else if (this.vip_info.vip_lv === 2) {
              this.grade_name = '九龙阁二级'
            } else if (this.vip_info.vip_lv === 3) {
              this.grade_name = '九龙阁三级'
            } else if (this.vip_info.vip_lv === 4) {
              this.grade_name = '九龙阁四级'
            } else if (this.vip_info.vip_lv === 5) {
              this.grade_name = '九龙阁五级'
            } else if (this.vip_info.vip_lv === 0) {
              this.grade_name = '非会员'
            }
          }
        })
      }
    }
  },
  mounted () {
    this.LogonExpires()
    if (this.user_datas.length !== 0) {
      this.getData()
    }
    // cookie记录清除时msg_reads.msg_reads初始化为undefined，页面回到首页
    if (this.msg_reads.msg_reads === undefined) {
      this.menuShow(0)
      this.$router.push('/')
    }
  }
}
</script>
<style lang='less' scoped rel="stylesheet/less">
.head {
  clear: both;
  z-index: 4;
  min-width: 1188px;
}

.userinfobox {
  clear: both;
  height: 36px;
  line-height: 36px;
  background: #111;
  padding-right:19% ;
}

.userinfo {
  font-size: 13px;
  color: #fff;
  .userinfo_details {
    float: right;
    margin-right: 54px;
    a {
      color: #fff;
      cursor: pointer;
    }
    span {
      float: left;
      margin-right: 20px;
      i {
        background: url('../../../static/img/home/loginico.png');
        height: 24px;
        width: 23px;
        margin-right: 5px;
        display: inline-block;
        margin-top: -3px;
        vertical-align: middle;
      }
    }
    .logout {
      margin-right: 17px;
      label{
        cursor: pointer;
      }
    }
  }
}
.logininfo {
  cursor: pointer;
  float: right;
}
.navbg {
  background: url('../../../static/img/home/navbg.png') no-repeat;
  background-size: 100% 100%;
  height: 130px;
  width: 100%;
}
.navlogo {
  height: 50px;
  width: 154px;
  float: left;
  margin-top: 30px;
  margin-right: 20px;
}
.navbg .nav {
  height: 97px;
  li {
    float: left;
    width: 113px;
    height: 97px;
    margin-right: 56px;
    .choose{
      text-shadow: 0 6px 26px #fff, 0 5px 26px #fff, 0 -6px 13px #fff;
      background: url(../../../static/img/home/navon.jpg)no-repeat;
      transition: all 300ms linear;
    }
    a {
      font-size: 18px;
      color: #fff;
      width: 113px;
      height: 97px;
      line-height: 86px;
      display: block;
      text-align: center;
      span {
        display: block;
        text-align: center;
        height: 16px;
        line-height: 20px;
        margin-top: -31px;
        font-size: 12px;
        font-family: "Microsoft YaHei";
        text-shadow: none;
      }
    }
    &:hover {
      text-shadow: 0 6px 26px #fff, 0 5px 26px #fff, 0 -6px 13px #fff;
      transition: text-shadow .5s;
      span {
        color: #fff;
      }
    }
  }
}
.navbg .nav li:last-child {
  margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue